import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { loginWithLinkedIn } from "../store/slices/authSlice";
import { Spin } from "antd";

const LinkedInCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const called = useRef(false);

  useEffect(() => {
    // Prevent strict mode double execution in React 18+
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");
    const errorDescription = params.get("error_description");

    const savedState = sessionStorage.getItem("linkedin_access_token");
    sessionStorage.removeItem("linkedin_access_token");

    if (error) {
      toast.error(`LinkedIn Login failed: ${errorDescription || error}`, { theme: "colored" });
      navigate("/login", { replace: true });
      return;
    }

    if (!code || state !== savedState) {
      toast.error("Invalid authorization request or state mismatch.", { theme: "colored" });
      navigate("/login", { replace: true });
      return;
    }

    // Dispatch thunk to send code to backend
    dispatch(loginWithLinkedIn({ code }))
      .unwrap()
      .then((response) => {
        toast.success(response?.message || "Successfully logged in with LinkedIn!", { theme: "colored" });
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        console.error("LinkedIn login error:", err);
        toast.error(err?.message || "LinkedIn Login failed on the server.", { theme: "colored" });
        navigate("/login", { replace: true });
      });
  }, [location, navigate, dispatch]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#1E1E1E]">
      <Spin size="large" />
      <h2 className="text-white mt-4 text-xl">Authenticating with LinkedIn...</h2>
    </div>
  );
};

export default LinkedInCallback;